/**
 * @file GameClock.ts
 * @role Monotonic GAME-time accumulator (ms), advanced only by clamped GameTicker dt.
 *       Logic that needs "how long since X" (e.g. min-spin-elapsed) reads this instead
 *       of Date.now()/performance.now(), so game time never jumps when a tab is hidden.
 * @owns Accumulated elapsed game time.
 * @reads Clamped dt from GameTicker (wired in the composition root).
 * @neverDoes Read wall-clock time. Advance while the ticker is paused.
 * @invariants 22 (single clamped clock).
 * @see docs/decisions/0003-deterministic-reel-engine.md
 */
export class GameClock {
  private elapsedMs = 0;

  /** Advance game time by one clamped frame delta. Wired to GameTicker.add(). */
  advance(deltaMs: number): void {
    this.elapsedMs += deltaMs;
  }

  /** Current game time in ms since reset. */
  now(): number {
    return this.elapsedMs;
  }

  /** Elapsed game time since a previously captured now(). */
  elapsedSince(markMs: number): number {
    return this.elapsedMs - markMs;
  }

  reset(): void {
    this.elapsedMs = 0;
  }
}
